import "./index.scss"
import EditTomSPrettyList from './blocks/edit'


import React, {useState} from 'react'
import { __ } from '@wordpress/i18n';
import {TextControl, TextareaControl, Button, Icon, PanelBody, PanelRow, ToggleControl, SelectControl, CheckboxControl, RadioControl, ToolbarButton} from "@wordpress/components"
import {InspectorControls, MediaUpload, MediaUploadCheck, BlockControls, AlignmentToolbar} from "@wordpress/block-editor"

const TomSPrettyListIcon = () => (
                            <Icon
                                icon={
                                    <svg t="1635785033866" className="toms-pretty-list-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6441" width="24" height="24">
                                        <path d="M44.701253 38.728163v946.453343l249.888246-11.004371 251.92657 11.094676h2.760768l18.228812-319.939519-304.329567 122.828394-37.063961-274.786765L290.138727 38.728163zM342.490121 204.735491a0.477329 0.477329 0 0 0-0.477329 0.477329v45.56558c0 0.258016 0.206413 0.477329 0.477329 0.477329h59.524232v209.199163c0 0.258016 0.206413 0.464428 0.464428 0.464429h79.288237c0.258016 0 0.477329-0.206413 0.47733-0.464429v-14.397278a111.578907 111.578907 0 0 1-39.773127-85.248401 111.578907 111.578907 0 0 1 39.773127-85.40321v-24.150274h114.817004c0.258016 0 0.464428-0.219313 0.464429-0.477329v-45.56558a0.477329 0.477329 0 0 0-0.477329-0.477329z m631.919253 0.258016v2.167332h6.747112v16.835527h2.580158V207.18664h6.747111v-2.167332z m18.551332 0v19.002859h2.489852v-16.680718l4.902299 13.029795h2.580158l4.902299-13.029795v16.680718h2.515653v-19.002859h-3.831533l-4.876498 12.939489-4.850696-12.939489z m-152.990434 26.704629l-17.944994 11.120478v30.678072H641.77548c-0.232214 0-0.438627 0.180611-0.438626 0.412825V291.519086a111.578907 111.578907 0 0 1 24.26638 69.303028 111.578907 111.578907 0 0 1-24.253479 69.470738v25.453253c0 0.258016 0.206413 0.477329 0.464428 0.477329h53.667274c0.258016 0 0.477329-0.219313 0.477329-0.477329V319.358984h42.353284v90.666732c0 0.193512 0.154809 0.348321 0.348321 0.348321h41.772749a0.348321 0.348321 0 0 0 0.348321-0.348321v-90.666732h41.243817v56.918273l17.932094 11.094677h94.898189c0.232214 0 0.425726 0.193512 0.425726 0.425726v73.986013a0.412825 0.412825 0 0 1-0.425726 0.412826H860.869547a0.412825 0.412825 0 0 1-0.412825-0.412826v-33.967772h-38.444345v73.831204c0 0.232214 0.206413 0.412825 0.438627 0.412826h134.516506l15.390639-9.546583V357.093786l-18.409423-11.391395H860.869547a0.412825 0.412825 0 0 1-0.412825-0.412825V271.303552c0-0.232214 0.180611-0.425726 0.412825-0.425726h73.986014c0.232214 0 0.425726 0.193512 0.425726 0.425726V305.232622H972.358149v-73.10876a0.412825 0.412825 0 0 0-0.412825-0.412825z m-46.313825 326.647929l0.528932 59.472628h-99.9811v358.474171h103.167594l0.141909 15.700257 134.24559-2.051225V678.73621z" opacity=".96" p-id="6442"></path>
                                        <path d="M499.570105 285.158998a19.415685 19.415685 0 0 0-18.964157 18.473927v112.752879a19.415685 19.415685 0 0 0 28.639747 16.113083l7.392151-3.76703v0.348321l68.425775-34.470903 68.425774-34.470903-68.425774-34.496705-68.425775-34.470903v0.090306l-7.392151-3.76703a19.415685 19.415685 0 0 0-9.67559-2.335042z m38.36694 42.546795a8.385512 8.385512 0 0 1 4.166955 1.019162l3.186494 1.6255v-0.051603l29.529902 14.874607 29.517 14.874608-29.517 14.874607-29.529902 14.874608v-0.129008l-3.186494 1.612598a8.385512 8.385512 0 0 1-12.358954-6.953524v-48.635967a8.385512 8.385512 0 0 1 8.191999-7.972687z" fill="#FF0000" p-id="6443"></path>
                                    </svg>                     
                                }
                            />
                        );

wp.blocks.registerBlockType("tomsneddon-pretty-list/toms-pretty-list", {
    title: __("TomS Pretty List", "toms-pretty-list"),
    icon: TomSPrettyListIcon,
    category: "tomsneddon",
    attributes: {
        // Pretty List Setting
        prettyList: {
            type: 'boolean',
            default: true
        },
        prettyListStyle: {
            type: 'string',
            default: 'default'
        },
        prettyListFontIcon: {
            type: 'boolean',
            default: false
        },
        prettyListFontIconOnlineUrl: {
            type: 'string',
            default: ''
        },
        prettyListSvg: {
            type: 'boolean',
            default: false
        },
        prettyListDefaultStyle: {
            type: 'boolean',
            default: true
        },
        prettyListLinkTitleLock: {
            type: 'boolean',
            default: false
        },
        prettyListLinkTitleNewTab: {
            type: 'boolean',
            default: false
        },
        prettyListLinkLock: {
            type: 'boolean',
            default: false
        },
        prettyListLinkNewTab: {
            type: 'boolean',
            default: false
        },
        prettyListTitleIcon: {
            type: 'string',
            default: ''
        },
        prettyListTitleSvgIcon: {
            type: 'string',
            default: ''
        },
        prettyListTitle: {
            type: 'string',
            default: ''
        },
        prettyListTitleLink: {
            type: 'string',
            default: ''
        },
        prettyListIcon: {
            type: 'array',
            default: ['']
        },
        prettyListSvgIcon: {
            type: 'array',
            default: ['']
        },
        prettyListContent: {
            type: 'array',
            default: ['']
        },
        prettyListLink: {
            type: 'array',
            default: ['']
        },

        //Pretty List Alignment
        prettyListTitleAlignment: {
            type: 'string',
            default: 'none'
        },
        prettyListContentAlignment: {
            type: 'string',
            default: 'none'
        },

        //Pretty List Boxing Background Color
        prettyListBoxBgColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },//margin
        prettyListBoxMargin: {
            type: 'number',
            default: 0
        },
        prettyListBoxMarginTop: {
            type: 'number',
            default: 0
        },
        prettyListBoxMarginRight: {
            type: 'number',
            default: 0
        },
        prettyListBoxMarginBottom: {
            type: 'number',
            default: 0
        },
        prettyListBoxMarginLeft: {
            type: 'number',
            default: 0
        },//padding
        prettyListBoxPadding: {
            type: 'number',
            default: 0
        },
        prettyListBoxPaddingTop: {
            type: 'number',
            default: 0
        },
        prettyListBoxPaddingRight: {
            type: 'number',
            default: 0
        },
        prettyListBoxPaddingBottom: {
            type: 'number',
            default: 0
        },
        prettyListBoxPaddingLeft: {
            type: 'number',
            default: 0
        },//borderRadius
        prettyListBoxBorderRadius: {
            type: 'number',
            default: 0
        },
        prettyListBoxBorderTopRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListBoxBorderTopLeftRadius: {
            type: 'number',
            default: 0
        },
        prettyListBoxBorderBottomRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListBoxBorderBottomLeftRadius: {
            type: 'number',
            default: 0
        },//Boxing px % em rem
        prettyListBoxMarginPX: {
            type: 'boolean',
            default: true
        },
        prettyListBoxMarginEM: {
            type: 'boolean',
            default: false
        },
        prettyListBoxMarginPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListBoxPaddingPX: {
            type: 'boolean',
            default: true
        },
        prettyListBoxPaddingEM: {
            type: 'boolean',
            default: false
        },
        prettyListBoxPaddingPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListBoxBorderRadiusPX: {
            type: 'boolean',
            default: true
        },
        prettyListBoxBorderRadiusEM: {
            type: 'boolean',
            default: false
        },
        prettyListBoxBorderRadiusPerCent: {
            type: 'boolean',
            default: false
        },

        // Pretty List Heading Style
        prettyListHeading: {
            type: 'number',
            default: 3
        },
        prettyListTitleFontSize: {
            type: 'number',
            default: 24
        },
        prettyListTitleFontIconSize: {
            type: 'number',
            default: 24
        },
        prettyListTitleSvgIconSizeWidth: {
            type: 'number',
            default: 24
        },
        prettyListTitleSvgIconSizeHeight: {
            type: 'number',
            default: 24
        },
        prettyListTitleIconColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },
        prettyListTitleFontColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },
        prettyListTitleBgColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },//Icon margin 
        prettyListHeadingIconMargin: {
            type: 'number',
            default: 0
        },
        prettyListHeadingIconMarginTop: {
            type: 'number',
            default: 0
        },
        prettyListHeadingIconMarginRight: {
            type: 'number',
            default: 0
        },
        prettyListHeadingIconMarginBottom: {
            type: 'number',
            default: 0
        },
        prettyListHeadingIconMarginLeft: {
            type: 'number',
            default: 0
        },//margin
        prettyListHeadingMargin: {
            type: 'number',
            default: 0
        },
        prettyListHeadingMarginTop: {
            type: 'number',
            default: 0
        },
        prettyListHeadingMarginRight: {
            type: 'number',
            default: 0
        },
        prettyListHeadingMarginBottom: {
            type: 'number',
            default: 0
        },
        prettyListHeadingMarginLeft: {
            type: 'number',
            default: 0
        },//padding
        prettyListHeadingPadding: {
            type: 'number',
            default: 0
        },
        prettyListHeadingPaddingTop: {
            type: 'number',
            default: 0
        },
        prettyListHeadingPaddingRight: {
            type: 'number',
            default: 0
        },
        prettyListHeadingPaddingBottom: {
            type: 'number',
            default: 0
        },
        prettyListHeadingPaddingLeft: {
            type: 'number',
            default: 0
        },//borderRadius
        prettyListHeadingBorderRadius: {
            type: 'number',
            default: 0
        },
        prettyListHeadingBorderTopRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListHeadingBorderTopLeftRadius: {
            type: 'number',
            default: 0
        },
        prettyListHeadingBorderBottomRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListHeadingBorderBottomLeftRadius: {
            type: 'number',
            default: 0
        },
        //Heading px % em rem
        prettyListTitleFontPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleFontEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleFontPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitleIconPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleIconEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleIconPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitleIconMarginPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleIconMarginEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleIconMarginPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitleSvgPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleSvgEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleSvgPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitleMarginPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleMarginEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleMarginPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitlePaddingPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitlePaddingEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitlePaddingPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListTitleBorderRadiusPX: {
            type: 'boolean',
            default: true
        },
        prettyListTitleBorderRadiusEM: {
            type: 'boolean',
            default: false
        },
        prettyListTitleBorderRadiusPerCent: {
            type: 'boolean',
            default: false
        },

        //Pretty List Content Style
        prettyListContentFontSize: {
            type: 'number',
            default: 16
        },
        prettyListContentFontIconSize: {
            type: 'number',
            default: 16
        },
        prettyListContentSvgIconSizeWidth: {
            type: 'number',
            default: 24
        },
        prettyListContentSvgIconSizeHeight: {
            type: 'number',
            default: 24
        },
        prettyListContentIconColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },
        prettyListContentFontColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },
        prettyListContentBgColor: {
            type: 'object',
            default: {
                r: '',
                g: '',
                b: '',
                a: ''
            }
        },//Icon margin 
        prettyListContentIconMargin: {
            type: 'number',
            default: 0
        },
        prettyListContentIconMarginTop: {
            type: 'number',
            default: 0
        },
        prettyListContentIconMarginRight: {
            type: 'number',
            default: 0
        },
        prettyListContentIconMarginBottom: {
            type: 'number',
            default: 0
        },
        prettyListContentIconMarginLeft: {
            type: 'number',
            default: 0
        },//margin
        prettyListContentMargin: {
            type: 'number',
            default: 0
        },
        prettyListContentMarginTop: {
            type: 'number',
            default: 0
        },
        prettyListContentMarginRight: {
            type: 'number',
            default: 0
        },
        prettyListContentMarginBottom: {
            type: 'number',
            default: 0
        },
        prettyListContentMarginLeft: {
            type: 'number',
            default: 0
        },//padding
        prettyListContentPadding: {
            type: 'number',
            default: 0
        },
        prettyListContentPaddingTop: {
            type: 'number',
            default: 0
        },
        prettyListContentPaddingRight: {
            type: 'number',
            default: 0
        },
        prettyListContentPaddingBottom: {
            type: 'number',
            default: 0
        },
        prettyListContentPaddingLeft: {
            type: 'number',
            default: 0
        },//borderRadius
        prettyListContentBorderRadius: {
            type: 'number',
            default: 0
        },
        prettyListContentBorderTopRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListContentBorderTopLeftRadius: {
            type: 'number',
            default: 0
        },
        prettyListContentBorderBottomRightRadius: {
            type: 'number',
            default: 0
        },
        prettyListContentBorderBottomLeftRadius: {
            type: 'number',
            default: 0
        },
        //Content px % em rem
        prettyListContentFontPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentFontEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentFontPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentIconPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentIconEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentIconPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentIconMarginPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentIconMarginEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentIconMarginPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentSvgPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentSvgEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentSvgPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentMarginPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentMarginEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentMarginPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentPaddingPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentPaddingEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentPaddingPerCent: {
            type: 'boolean',
            default: false
        },
        prettyListContentBorderRadiusPX: {
            type: 'boolean',
            default: true
        },
        prettyListContentBorderRadiusEM: {
            type: 'boolean',
            default: false
        },
        prettyListContentBorderRadiusPerCent: {
            type: 'boolean',
            default: false
        },
    },
    description: __("Simple and beautiful list block. Support all font icon library and SVG icon.", "toms-pretty-list"),
    // example: {
    //     title: __("TomS Pretty List", "toms-pretty-list")
    // },
    edit: function (props) {
        return(
            <>
                <EditTomSPrettyList {...props} />

                {/* Change the TomS Blocks Category Icon */
                    ( function () {                   
                        const TomSBlocksIcon = () => (
                            <Icon
                                icon={
                                    <svg t="1633509965289" className="toms-blocks-icon" viewBox="0 0 1078 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2725" width="24" height="24">
                                        <path d="M9.872126 282.058576a0.755905 0.755905 0 0 0-0.755906 0.755905v72.94488c0 0.423307 0.347717 0.755905 0.755906 0.755906h95.274328v334.866133c0 0.408189 0.332598 0.740787 0.755906 0.740788H232.818892a0.755905 0.755905 0 0 0 0.755905-0.755906v-23.039999a178.590232 178.590232 0 0 1-63.66236-136.45606 178.590232 178.590232 0 0 1 63.647242-136.697949v-38.657007h183.775744a0.755905 0.755905 0 0 0 0.755905-0.755906v-72.94488a0.755905 0.755905 0 0 0-0.755905-0.755905z m1011.47714 0.423307v3.462047h10.794331v26.95559h4.142362v-26.95559h10.79433v-3.477165z m29.707086 0v30.417637h3.991181V286.18582l7.831181 20.862991h4.15748l7.831181-20.862991v26.7137h4.021417v-30.417637h-6.137952l-7.800945 20.696692-7.75559-20.71181z m-244.883143 42.738896l-28.724409 17.794016v49.103621H488.919673c-0.377953 0-0.695433 0.302362-0.695433 0.650078V420.948651a178.590232 178.590232 0 0 1 38.853542 110.921572 178.590232 178.590232 0 0 1-38.853542 111.17858v40.758424c0 0.423307 0.332598 0.755905 0.755905 0.755906h85.901101a0.755905 0.755905 0 0 0 0.755905-0.755906v-218.305506h67.804723v145.118736c0 0.302362 0.24189 0.574488 0.55937 0.574489h66.852282c0.302362 0 0.574488-0.257008 0.574488-0.574489V465.486603h65.99055v91.116848l28.70929 17.748661H958.034622c0.377953 0 0.680315 0.302362 0.680315 0.680315v118.435272c0 0.362835-0.302362 0.680315-0.680315 0.680315h-118.420154a0.680315 0.680315 0 0 1-0.680315-0.680315v-54.364723h-61.515589V757.281241c0 0.362835 0.302362 0.665197 0.680314 0.665197h215.327239l24.642519-15.269291V525.89857l-29.480314-18.232441h-148.973854a0.665197 0.665197 0 0 1-0.680315-0.680315v-118.420154c0-0.377953 0.302362-0.680315 0.680315-0.680315h118.420154c0.377953 0 0.680315 0.302362 0.680315 0.680315V442.915265h59.353699v-117.014171a0.680315 0.680315 0 0 0-0.680315-0.680315z" opacity=".96" p-id="2726"></path><path d="M267.363773 425.484084a26.910236 26.910236 0 0 0-26.275275 25.564724v156.215429a26.910236 26.910236 0 0 0 39.66992 22.284094l10.250079-5.215748v0.498898l94.790549-47.758109 94.77543-47.742991-94.790548-47.773227-94.775431-47.75811v0.151182l-10.250079-5.230866a26.910236 26.910236 0 0 0-13.394645-3.235276zM320.503929 484.38424a11.610708 11.610708 0 0 1 5.775118 1.405984l4.429606 2.267717v-0.090709l40.879369 20.605984 40.909606 20.621102-40.909606 20.590865-40.879369 20.605984v-0.196535l-4.429606 2.267716a11.610708 11.610708 0 0 1-17.1137-9.645354v-67.381416a11.610708 11.610708 0 0 1 11.338582-11.03622z" fill="#FF0000" p-id="2727"></path>
                                    </svg>
                                }
                            />
                        );
                        wp.blocks.updateCategory( 'tomsneddon', { icon: TomSBlocksIcon } );
                    } )()
                }
            </>
        )
    },
    save: function (props) {
        return null
    }
})